export enum CarriersStatusesEnum {
    'Активирован' = 'green',
    'Создан' = 'primary',
    'Неактивный' = 'red',
}
